import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { GlobalMerchantProvider } from "utils/helper";
import ECThemeContainer from 'containers/ECThemeContainer';
import NotFoundComponent from 'components/NotFoundComponent';
import "./App.css";
import "./assets/global.css";

function App() {
  localStorage.setItem("userTheme", "light");
  const RouterAny: any = Router;
  const SwitchAny: any = Switch;
  const RouteAny: any = Route;
  return (
    <HelmetProvider>
      <GlobalMerchantProvider>
        <RouterAny>
          <SwitchAny>
            <RouteAny path="/404" component={NotFoundComponent} />
            <RouteAny path="/" component={ECThemeContainer} />
          </SwitchAny>
        </RouterAny>
      </GlobalMerchantProvider>
    </HelmetProvider>
  );
}

export default App;
